import './Spinner.css';

interface SpinnerProps {
  /** Uppercase status text beside the mark. */
  label?: string;
  tone?: 'blue' | 'amber';
  className?: string;
}

export default function Spinner({
  label,
  tone = 'blue',
  className,
}: SpinnerProps) {
  const classes = [
    'spinner',
    tone === 'amber' ? 'spinner--amber' : null,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <span className={classes} role="status">
      <span className="spinner__mark" aria-hidden="true" />
      {label ? <span className="spinner__text">{label}</span> : null}
    </span>
  );
}
